import { AccountData } from "components/form/graphql/types";

export const createLaunchDarklyContext = (data: AccountData) => {
  const regionalLocation = process.env.REACT_APP_REGIONAL_LOCATION ?? "EU";
  const isFedRamp = regionalLocation === "US-fedramp";

  return {
    kind: "user",
    admin: data.viewer.admin,
    key: isFedRamp ? "anonymous" : data.viewer.id,
    email: isFedRamp ? "" : data.viewer.email,
    name: isFedRamp ? "" : data.viewer.name,
    account_name: data.accountName,
    account_type: data.accountType,
    identity_provider: isFedRamp ? "" : data.viewer.identityProvider,
    pr: process.env.REACT_APP_PR_ID,
    regional_location: regionalLocation,
  };
};
